export default __webpack_public_path__ + "static/media/3.675be2f0.webp";